// src/lib/utilities/ga.js
export function sendGAEvent(
    eventCategory,
    eventAction,
    eventLabel,
    currentTab,
    callback // optional function to call after GA is done sending
) {
    if (typeof gtag === 'function') {
        // Construct the parameter object
        const params = {
            event_category: eventCategory,
            event_label: eventLabel,
            current_tab: currentTab
        };

        // If a callback is provided, attach event_callback and a timeout
        if (typeof callback === 'function') {
            params.event_callback = callback;
            params.event_timeout = 2000; // 2s fallback if the callback never fires
        }

        // Fire the GA event
        gtag('event', eventAction, params);
    } else {
        // GA4 not loaded or not available
        console.warn('GA4 is not loaded. Event not sent:', {
            eventCategory,
            eventAction,
            eventLabel,
            currentTab
        });

        // If we have a callback, call it immediately so the app doesn't get stuck
        if (typeof callback === 'function') {
            callback();
        }
    }
}